module.exports = __webpack_public_path__ + "e0106718/img/share-action-icon.9c12578c.svg";